import script from "./ContactMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ContactMessage.vue?vue&type=style&index=0&id=be75e1f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be75e1f4"]])

export default __exports__